import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import StrangerDashboard from "./StrangerDashboard";
import PhotographerDashboard from "./PhotographerDashboard";

export default function Dashboard() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "admin" || user.role === "super_admin") return <Navigate to="/admin" replace />;
  if (user.role === "photographer") return <PhotographerDashboard />;
  return <StrangerDashboard />;
}
